export const getDefaultCollection = (collections: ProductCatalogItemsList): ProductCatalogItem =>
    Object.values(collections)[0][0];
